<template>
  <div>
    <el-table
        :data="list"
    >
      <el-table-column label="参考线名">
        <template v-slot="{ row, $index }">
          <el-input size="small" controls-position="right"
                    v-model="row.name"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="值类型" min-width="90px">
        <template v-slot="{ row, $index }">
          <el-select v-model="row.type" size="small">
            <el-option label="固定值" value="fixed"/>
            <el-option label="动态值" value="dynamic"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="指标">
        <template v-slot="{ row, $index }">
          <el-select v-if="row.type === 'dynamic'" v-model="row.metric" size="small">
            <el-option v-for="(item, index) in metricOption"
                       :key="index" :label="item.name" :value="item.code"/>
          </el-select>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="参考线值" min-width="90">
        <template v-slot="{ row, $index }">
          <el-select v-if="row.type === 'dynamic'" v-model="row.valueType" size="small">
            <el-option v-for="(item, index) in symbolKind" :key="index" :label="item.label" :value="item.value"/>
          </el-select>
          <el-input-number v-else style="width: 80px" size="small" controls-position="right"
                           v-model="row.value"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="参考线线型" min-width="90px">
        <template v-slot="{ row, $index }">
          <el-select v-model="row.yAxisMarkLineType" size="small">
            <el-option label="实线" value="solid"/>
            <el-option label="虚线" value="dashed"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="参考线粗细" min-width="90">
        <template v-slot="{ row, $index }">
          <el-input-number style="width: 80px" size="small" controls-position="right"
                           v-model="row.yAxisMarkLineWidth"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="参考线颜色">
        <template v-slot="{ row, $index }">
          <el-color-picker :predefine="predefineColors" show-alpha v-model="row.yAxisMarkLineColor"></el-color-picker>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template v-slot="{ row, $index }">
          <el-link type="primary" @click="list.splice($index,1)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-button type="primary" style="width: 100%" class="mt-10 mb-10"
               @click="add()">
      添加
    </el-button>
  </div>
</template>
<script setup>
// 兼顾双碳 智脑 低代码平台多项目，高效完成需求开发，保障双碳606 620版本如期上线，完成智脑看板低代码搭建与自开融合组件的开发，保障项目顺利推进
import {ref} from "vue";
import {cloneDeep} from "lodash-es";
import colorPicker from '@/option/components/commonSet/color-picker.vue'
import {ElMessage} from "element-plus";
import {predefineColors} from "@/option/common/dict";

const props = defineProps({
  main: {},
  // 是否为副指标轴参考线配置
  isSub: {
    type: Boolean
  }
})
let metricKeys = ["metrics", "reference", "assistMetrics", "totalMetrics", "metricsR", "metricsL"];

const list = ref([])
if (props.main.activeOption.referenceCustomSet && !props.isSub) {
  list.value = cloneDeep(props.main.activeOption.referenceCustomSet)
}
if (props.main.activeOption.rightReferenceCustomSet && props.isSub) {
  list.value = cloneDeep(props.main.activeOption.rightReferenceCustomSet)
}
const metricOption = computed(() => {
  let metrics = []
  metricKeys.forEach((el) => {
    let _cf = props.main.activeObj.prop?.[el];
    if (_cf?.length) {
      _cf.forEach((el) => {
        metrics.push(el);
      });
    }
  });
  return metrics;
})

const symbolKind = [
  {label: "平均值", value: "avg"},
  {label: "最大值", value: "max"},
  {
    label: "最小值",
    value: "min"
  },
  {label: "中位数", value: "mid"}]

function add() {
  list.value.push({
    type: 'fixed',
    yAxisMarkLineType: 'solid'
  })
}

defineExpose({
  getSetting() {
    list.value.forEach((el) => {
      if (el.type === 'dynamic') {
        if (!el.metric || !el.valueType) {
          ElMessage.warning('请选择指标和参考线值！')
          throw new Error('请选择指标和参考线值！')
        }
      } else if (el.value === undefined || el.value === null) {
        ElMessage.warning('请输入参考线值！')
        throw new Error('请输入参考线值！')
      }
    })
    return cloneDeep(list.value)
  }
})
</script>
<style lang="scss">

</style>